import React from 'react';
import { useSelector } from 'react-redux';
import TaskListContent from "./TaskListContent";

const TaskList = ({slug, header}) => {
    const {userTaskOrdered, userTaskColumns} = useSelector((state) => state.settings.myTask);
    return (
      <TaskListContent tasks={userTaskColumns && userTaskColumns[slug] && userTaskColumns[slug].length>0?userTaskColumns[slug]:[]} header={header} />
  );
};

export default TaskList;
